import * as types from '../actions/actionTypes';
import initialState from './initialState';
import { IinitialState } from '../types/rootState';

/*
 * Tracks an in-flight synchronous report preview so the header CubeLoader can show for the
 * whole call. It does not reuse ajaxCallsInProgress because that counter is decremented by
 * ANY action type ending in _SUCCESS/_FAILED, so an unrelated call finishing mid-render
 * drops it to zero and the loader disappears while the preview is still running.
 *
 * Transient state: registered top-level and blacklisted from persistence (like
 * ajaxCallsInProgress) so a reload can never rehydrate a stuck loader.
 */
export default function reportPreviewGeneratingReducer(
    state: boolean = initialState.isGeneratingReportPreview,
    action: any
): boolean {
    switch (action.type) {
        case types.SET_REPORT_PREVIEW_GENERATING:
            return action.payload;
        default:
            return state;
    }
}

export const selectIsGeneratingReportPreview = (state: IinitialState): boolean => state.isGeneratingReportPreview;
